export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/comment-dots-gradient.6be11f8c.svg","height":24,"width":31};